export default `
	headline
	list {
		...on ListItem {
			paragraph {
				content
			}
		}
	}
`;
